/** Phase 18 — supermarketPayments lesen. */

import { listAggregateSupermarketPayments } from '../infrastructure/storage/domainAggregateStore';
import { listEntitySupermarketPayments } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'supermarketPayments',
  listAggregate: listAggregateSupermarketPayments,
  listEntity: listEntitySupermarketPayments,
  idKeys: ['id', 'paymentId']
});

export const readSupermarketPaymentsFromMergedBlob = source.readFromMergedBlob;
export const readSupermarketPaymentsFromBestSource = source.readFromBestSource;
export const refreshSupermarketPaymentsReadCache = source.refreshReadCache;
export const getCachedSupermarketPaymentsRead = source.getCachedRead;
export const clearSupermarketPaymentsReadCache = source.clearReadCache;
export const readSupermarketPaymentsSyncForBusiness = source.readSyncForBusiness;
